import {useContext, useEffect} from 'react';
import dayjs, { isDayjs } from 'dayjs';
import duration from 'dayjs/plugin/duration';
import ProDescriptions from "@ant-design/pro-descriptions";
import {Divider} from "antd";
import { DigitalAssetPageContext } from './DigitalAssetsPage';
import React from 'react';

dayjs.extend(duration);

const formatDuration = (duration: number) => {
    // Extract whole minutes
    const minutes = Math.floor(duration / 60);

    // Extract remaining whole seconds
    const seconds = Math.floor(duration % 60);

    // Extract milliseconds
    const milliseconds = Math.round((duration % 1) * 1000);

    // Format the result as mm:ss:SSS
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');
    const formattedMilliseconds = String(milliseconds).padStart(3, '0');

    return `${formattedMinutes}:${formattedSeconds}.${formattedMilliseconds}`;
};

const parseDuration = (durationString: string) => {
    // console.log({durationString})
    if (!isNaN(+durationString)) {
        return dayjs.duration(+durationString);
    }
    if (!durationString) {
        return dayjs.duration(0);
    }
    // Split the duration string into minutes, seconds, and milliseconds
    const [minutes, secondsWithMillis] = durationString.split(':');
    const [seconds, milliseconds] = secondsWithMillis.split('.');

    // Create a Day.js duration object
    const dur = dayjs.duration({
        minutes: parseInt(minutes, 10),
        seconds: parseInt(seconds, 10),
        milliseconds: parseInt(milliseconds, 10)
    });

    return dur;
};

const AddFormThirdPage = () => {
    const {firstFormPageRef, secondFormPageRef, listRef, artists, stepFormRef} = useContext(DigitalAssetPageContext);
    // const fileInputRef = useRef(null);

    useEffect(() => {
        console.log('FormPageRef', firstFormPageRef?.current?.getFieldsValue());
      }, [firstFormPageRef]);

    return (
        <>
            <h2 style={{color: '#1890ff'}}>Release Details</h2>
            <Divider/>
            <ProDescriptions column={2}>
                <ProDescriptions.Item label='Release Title'>
                {firstFormPageRef?.current?.getFieldValue('name') || <i>N/A</i>}
                </ProDescriptions.Item>

                <ProDescriptions.Item label='Version/Subtitle'>
                    {firstFormPageRef?.current?.getFieldValue('subtitle') || <i>N/A</i>}
                </ProDescriptions.Item>

                <ProDescriptions.Item label="UPC/EAN">
                    {firstFormPageRef?.current?.getFieldValue('upc_ean') || <i>N/A</i>}
                </ProDescriptions.Item>
    
                <ProDescriptions.Item label="Main Artists">
                    {firstFormPageRef?.current?.getFieldValue('artists') || <i>N/A</i>}
                </ProDescriptions.Item>

                <ProDescriptions.Item label="Featuring Artists">
                    {firstFormPageRef?.current?.getFieldValue('featuring_artists') || <i>N/A</i>}
                </ProDescriptions.Item>

                <ProDescriptions.Item label="Label">
                    {firstFormPageRef?.current?.getFieldValue('label_id') || <i>N/A</i>}
                </ProDescriptions.Item>

                <ProDescriptions.Item label="Asset Label">
                    {firstFormPageRef?.current?.getFieldValue('asset_label_id') || <i>N/A</i>}
                </ProDescriptions.Item>

                <ProDescriptions.Item label="Genre">
                    {firstFormPageRef?.current?.getFieldValue('genre') || <i>N/A</i>}
                </ProDescriptions.Item>

                <ProDescriptions.Item label="Subgenre">
                    {firstFormPageRef?.current?.getFieldValue('sub_genre') || <i>N/A</i>}
                </ProDescriptions.Item>

                <ProDescriptions.Item label="Format">
                    {firstFormPageRef?.current?.getFieldValue('type') || <i>N/A</i>}
                </ProDescriptions.Item>

                <ProDescriptions.Item label='Digital Release Date'>
                    {typeof firstFormPageRef?.current?.getFieldValue('digital_release_date') == 'string' ?
                        dayjs(firstFormPageRef?.current?.getFieldValue('digital_release_date')).format('YYYY-MM-DD') :
                        isDayjs(firstFormPageRef?.current?.getFieldValue('digital_release_date')) ?
                            firstFormPageRef?.current?.getFieldValue('digital_release_date').format('YYYY-MM-DD') :
                            <i>N/A</i>}
                </ProDescriptions.Item>

                <ProDescriptions.Item label='Original Release Date'>
                    {typeof firstFormPageRef?.current?.getFieldValue('original_release_date') == 'string' ?
                        dayjs(firstFormPageRef?.current?.getFieldValue('original_release_date')).format('YYYY-MM-DD') :
                        isDayjs(firstFormPageRef?.current?.getFieldValue('original_release_date')) ?
                            firstFormPageRef?.current?.getFieldValue('original_release_date').format('YYYY-MM-DD') :
                            <i>N/A</i>}
                </ProDescriptions.Item>

                <ProDescriptions.Item label='Production Year'>
                    {typeof firstFormPageRef?.current?.getFieldValue('production_year') == 'string' ?
                        dayjs(firstFormPageRef?.current?.getFieldValue('production_year')).format('YYYY') :
                        isDayjs(firstFormPageRef?.current?.getFieldValue('production_year')) ?
                            firstFormPageRef?.current?.getFieldValue('production_year').format('YYYY') :
                            <i>N/A</i>}
                </ProDescriptions.Item>

                <ProDescriptions.Item label="Price Tier">
                    {firstFormPageRef?.current?.getFieldValue('price_tier') || <i>N/A</i>}
                </ProDescriptions.Item>

                <ProDescriptions.Item label="Release Territories">
                    {firstFormPageRef?.current?.getFieldValue('territories') || <i>N/A</i>}
                </ProDescriptions.Item>

                <ProDescriptions.Item label="Cover Art">
                    {firstFormPageRef?.current?.getFieldValue('album_cover_filename')  || <i>N/A</i>}
                </ProDescriptions.Item>
            </ProDescriptions>

            <br/>
            <h2 style={{color: '#1890ff'}}>Art track Details</h2>
            <Divider/>

            <ProDescriptions column={6}>
            {secondFormPageRef?.current &&
            secondFormPageRef?.current.getFieldValue('art_tracks')?.length > 0 ? (
            secondFormPageRef?.current.getFieldValue('art_tracks').map((track, index) => (
            <React.Fragment key={index}>
                <ProDescriptions.Item label="Vol. No">{track.volume_number || <i>N/A</i>}</ProDescriptions.Item>
                <ProDescriptions.Item label="Track No">{track.track_number}</ProDescriptions.Item>
                <ProDescriptions.Item label="Title">{track.title || <i>N/A</i>}</ProDescriptions.Item>
                {/* <ProDescriptions.Item label="Track Genre">{track.track_primary_genre || <i>N/A</i>}</ProDescriptions.Item>
                <ProDescriptions.Item label="Track Label">{track.track_label || <i>N/A</i>}</ProDescriptions.Item> */}
                <ProDescriptions.Item label="ISRC">{track.isrc || <i>N/A</i>}</ProDescriptions.Item>
                <ProDescriptions.Item label="Artist">{track.artist || <i>N/A</i>}</ProDescriptions.Item>
                <ProDescriptions.Item label="Filename">{track.filename || <i>N/A</i>}</ProDescriptions.Item>
            </React.Fragment>
            ))
  ) : (
    <ProDescriptions.Item label="Tracks">
      <i>Loading or No Tracks Available</i>
    </ProDescriptions.Item>
  )}
            </ProDescriptions>
        </>
    );
};

export default AddFormThirdPage;
